/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Wrapped_NoneInputs */

const en_us2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No finished week yet`)
};

const pt_br2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem semana fechada ainda`)
};

const es_419_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay semana cerrada`)
};

const pt_pt2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem semana fechada`)
};

const fr_fr2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore de semaine terminée`)
};

const de_de2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine abgeschlossene Woche`)
};

const it_it2_progress_wrapped_none = /** @type {(inputs: Progress_Wrapped_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna settimana conclusa`)
};

/**
* | output |
* | --- |
* | "No finished week yet" |
*
* @param {Progress_Wrapped_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_wrapped_none = /** @type {((inputs?: Progress_Wrapped_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Wrapped_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_wrapped_none(inputs)
	if (locale === "es-419") return es_419_progress_wrapped_none(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_wrapped_none(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_wrapped_none(inputs)
	if (locale === "de-DE") return de_de2_progress_wrapped_none(inputs)
	if (locale === "it-IT") return it_it2_progress_wrapped_none(inputs)
	return en_us2_progress_wrapped_none(inputs)
});
export { progress_wrapped_none as "progress.wrapped_none" }